import { createRequestTypes } from '../utils';

// export const TASK_LIST = createRequestTypes('task/TASK_LIST');
// export const SAVE_TASK = createRequestTypes('task/SAVE_TASK');
// export const DELETE_TASK = createRequestTypes('task/DELETE_TASK');
// export const UPDATE_TASK_STATUS = createRequestTypes('task/UPDATE_TASK_STATUS');
export const START_SESSION = createRequestTypes('session/START_SESSION');
export const STOP_SESSION = createRequestTypes('session/STOP_SESSION');
